// Legal's four contract stages, as the project's Overview row shows them, from the same
// row. That row has no history, so a past briefing leaves the card out.
import { useDashboard } from "../api/hooks/useDashboard";
import { ContractStages } from "./ContractStages";
import { SectionBlock, SectionCard } from "./SpecialistRowSections";
import styles from "./ContractsCard.module.css";

export const ContractsCard = ({ projectId }: { projectId: string }) => {
  const { data, error } = useDashboard(projectId);
  const row = data?.projects[0];
  return (
    <SectionCard title="Contracts" aside={null}>
      <SectionBlock>
        {error ? (
          <p className={styles.error}>Could not load the contract stages.</p>
        ) : !data ? (
          <p className={styles.muted}>Loading…</p>
        ) : !row ? (
          <p className={styles.muted}>This project is not on the dashboard.</p>
        ) : (
          <div className={styles.contracts}>
            <ContractStages
              row={row}
              definitions={new Map(data.attributes.map((a) => [a.key, a]))}
            />
          </div>
        )}
      </SectionBlock>
    </SectionCard>
  );
};
